import { Form, Modal, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import IApplicationProperty from '~Api/Application/IApplicationProperty';
import { applicationPropertyValuerValuationOrderedAction } from '~Applications/actions';
import DatePicker from '~UI/DatePicker';
import TimePicker from '~UI/TimePicker';
import IValuer from '~Valuers/IValuer';

export default function ValuationOrderedModal(props: {
    applicationProperty: IApplicationProperty;
    isOpen: boolean;
    onCancel: () => void;
    valuer: IValuer;
}): ReactElement {
    const {
        applicationProperty,
        isOpen,
        onCancel,
        valuer,
    } = props;

    const dispatch: Dispatch = useDispatch();

    const [ valuationDueDate, setValuationDueDate ] = useState<string | null>(null);
    const [ valuationOrderedDateTime, setValuationOrderedDateTime ] = useState<string | null>(null);

    const valuationDueDateDayJs: Dayjs | null = valuationDueDate ? dayjs(valuationDueDate) : null;
    const valuationOrderedDateTimeDayJs: Dayjs | null = valuationOrderedDateTime ? dayjs(valuationOrderedDateTime) : null;

    const onChangeValuationOrderedDate: (date: Dayjs) => void = useCallback((date: Dayjs): void => {
        setValuationOrderedDateTime((previousValuationOrderedDateTime: string | null): string => dayjs(
            `${date.format('YYYY-MM-DD')} ${dayjs(previousValuationOrderedDateTime || undefined).format('HH:mm')}`,
        ).format());
    }, []);

    const onChangeValuationOrderedTime: (time: Dayjs) => void = useCallback((time: Dayjs): void => {
        setValuationOrderedDateTime((previousValuationOrderedDateTime: string | null): string => dayjs(
            `${dayjs(previousValuationOrderedDateTime || undefined).format('YYYY-MM-DD')} ${time.format('HH:mm')}`,
        ).format());
    }, []);

    const onChangeDueDate: (date: Dayjs) => void = useCallback((date: Dayjs): void => {
        setValuationDueDate((previousValuationDueDate: string | null): string => dayjs(
            `${date.format('YYYY-MM-DD')} ${dayjs(previousValuationDueDate || undefined).format('HH:mm')}`,
        ).format());
    }, []);

    const onClickOk: () => void = useCallback((): void => {
        dispatch(applicationPropertyValuerValuationOrderedAction(
            applicationProperty.uuid,
            valuer.uuid,
            valuationDueDate,
            valuationOrderedDateTime,
        ));

        onCancel();
    }, [
        applicationProperty.uuid,
        dispatch,
        onCancel,
        valuationDueDate,
        valuationOrderedDateTime,
        valuer.uuid,
    ]);

    return (
        <Modal
            okText='Valuation Ordered'
            onCancel={onCancel}
            onOk={onClickOk}
            open={isOpen}
            title='Valuation Ordered'
            wrapClassName='property-valuation-order-valuation-modal'
        >
            <Form.Item className='ordered-date' label='Order Date'>
                <Space>
                    <DatePicker
                        className='ordered-date-datepicker'
                        format='DD/MM/YYYY'
                        onChange={onChangeValuationOrderedDate}
                        value={valuationOrderedDateTimeDayJs || dayjs()}
                    />
                    <TimePicker
                        className='ordered-date-timepicker'
                        format='H:mm'
                        onChange={onChangeValuationOrderedTime}
                        value={valuationOrderedDateTimeDayJs || dayjs()}
                    />
                </Space>
            </Form.Item>
            <Form.Item className='valuation-due-date' label='Due Date'>
                <DatePicker
                    className='valuation-due-date-datepicker'
                    format='DD/MM/YYYY'
                    onChange={onChangeDueDate}
                    value={valuationDueDateDayJs || dayjs()}
                />
            </Form.Item>
        </Modal>
    );
}
